import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { NgbDateFRParserFormatter } from './ngb-date-fr-parser-formatter';
import { NgbDateParserFormatter, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date';
import { Subscription } from 'rxjs';
import { SeaculumAngularFormlyService } from '../../services/saeculum-angular-formly.service';
import { INFO_ICON } from '../../constant/common.constant';
import { FormBaseClass } from '../shared/base-class/form-base-class';

@Component({
    selector: 'saeculum-input-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.component.scss'],
    providers: [{ provide: NgbDateParserFormatter, useClass: NgbDateFRParserFormatter }]
})
export class DatepickerComponent extends FormBaseClass implements OnInit, OnChanges {
    @Input() fieldObj: any;
    @Input() options;
    @Input() values;

    @Input() form: FormGroup;
    @Output() valueChange = new EventEmitter<any>();

    infoIcon = INFO_ICON.icon;

    constructor(public config: NgbDatepickerConfig) {
        super();
    }

    ngOnInit() {
        this.addControl();

        if (this.fieldObj && this.fieldObj.validators.minDate) { this.config.minDate = this.parse(this.fieldObj.validators.minDate); }
        if (this.fieldObj && this.fieldObj.validators.maxDate) { this.config.maxDate = this.parse(this.fieldObj.validators.maxDate); }
        this.config.outsideDays = 'hidden';
        if (this.values && this.values[this.fieldObj.key] && this.form.get(this.fieldObj.key)) {
            this.form.get(this.fieldObj.key).setValue(this.parse(this.values[this.fieldObj.key]));
        }


    }

    addControl() {
        this.form.addControl(this.fieldObj.key, new FormControl(this.values ? this.values[this.fieldObj.key] : null));
        this.setValidations(this.form, this.fieldObj);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.values && changes.values.currentValue && this.form.get(this.fieldObj.key)) {
            const date: any = this.parse(changes.values.currentValue);
            this.form.get(this.fieldObj.key).setValue(date);
        }
    }

    notifyChange() {
        if (this.form && this.fieldObj.key && this.form.controls[this.fieldObj.key].value) {
            this.valueChange.emit({ key: this.fieldObj.key, value: this.transform(this.form.controls[this.fieldObj.key].value) });
        }
    }

    transform(value: NgbDate): Date {
        return new Date(value.year, value.month, value.day);
    }

    parse(date) {
        let returnDate = null;
        if (this.checkValidDate(date)) {
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            returnDate = { year, month, day };
        }
        return returnDate;
    }

    checkValidDate(d) {
        let isValid = false;
        if (Object.prototype.toString.call(d) === "[object Date]") {
            // it is a date
            if (isNaN(d.getTime())) {  // d.valueOf() could also work
                // date is not valid
                isValid = false;
            } else {
                // date is valid
                isValid = true;
            }
        } else {
            // not a date
            isValid = false;
        }
        return isValid;
    }

}
